import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const CollectionIdDisplay = ({ _collectionID,color="white" }) => {
  const [isRevealed, setIsRevealed] = useState(false);

  const handleToggle = () => {
    setIsRevealed(!isRevealed);
  };

  return (
    <div className="collection-id" style={{color:`${color}`}}>
      <br />
      <b>Orders</b>
      <br />
      <font style={{ fontWeight: 'normal' }}>
        {isRevealed
          ? _collectionID
          : _collectionID.slice(0, -4).replace(/./g, '*') + _collectionID.slice(-4)}
      </font>
      <font onClick={handleToggle} style={{marginLeft:"5px",border: 'none', background: 'transparent',color:`${color}`, cursor: 'pointer' }}>
        {isRevealed ? <FaEyeSlash /> : <FaEye />}
      </font>
    </div>
  );
};

export default CollectionIdDisplay;
